import { type ReactElement } from 'react';
import { Button as ReactAriaButton, type ButtonProps } from 'react-aria-components';

export type DialogButtonProps = ButtonProps;

export function DialogButton(props: DialogButtonProps): ReactElement {
  return <ReactAriaButton {...props} />;
}
